import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { GlobalVariable } from './../../shared/global';
import 'rxjs/add/operator/toPromise';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable()
export class ManageCardsService {
  // private baseApiUrl = GlobalVariable.BASE_API_URL;
  private baseApiUrlTest = GlobalVariable.BASE_API_URL;
  private headers = new Headers({'Content-Type': 'application/json'});
  // private save_card = this.baseApiUrl + 'api/rest/v1/save/card/detail/';
  private save_card = this.baseApiUrlTest + 'api/ManageCard/save/card/detail';

  // private get_cards = this.baseApiUrl + 'api/rest/v1/get/card/detail/';
  private get_cards = this.baseApiUrlTest + 'api/ManageCard/get/card/detail';
  private get_payment_profiles = this.baseApiUrlTest + 'api/ManageCard/profiles';
  // private set_primary_card = this.baseApiUrl + 'api/rest/v1/primary/card/';
  private set_primary_card = this.baseApiUrlTest + 'api/ManageCard/set/primary';
  // private set_auto_pay = this.baseApiUrl + 'api/rest/v1/setup/autopay/';
  private set_auto_pay = this.baseApiUrlTest + 'api/payment/update/autopayamount/';
  private update_auto_pay = this.baseApiUrlTest + 'api/autopay/status';
  private toggle_auto_pay = this.baseApiUrlTest + 'api/autopay/toggle';
  // private set_auto_pay_threshold = this.baseApiUrl + 'api/rest/v1/setup/threshold/';
  private set_auto_pay_threshold = this.baseApiUrlTest + 'api/payment/update/autopayamount/';
  // private get_auto_pay = this.baseApiUrl + 'api/rest/v1/check/autopayment/';
  private get_auto_pay = this.baseApiUrlTest + 'api/payment/check/autopayment';
  private get_auto_pay_status = this.baseApiUrlTest + 'api/autopay/status';
  private delete_card = this.baseApiUrlTest + 'api/ManageCard/delete/card/detail/';
  private delete_payment_profile = this.baseApiUrlTest + 'api/ManageCard/delete/card/detail/';
  private validate_card = this.baseApiUrlTest + 'api/ManageCard/validate/card/detail';
  private update_card = this.baseApiUrlTest + 'api/ManageCard/update/card/detail';

  constructor(private http: Http, private localStorageService: LocalStorageService) { }

  saveCard(card_detail: Object) {
      return this.http
        .post(this.save_card, card_detail)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  }

  getCards(token: Object) {
    return this.getPaymentProfiles(token['token'])
  }
  getAutoPayStatus(token: string) {
    return this.http
      .get(this.get_auto_pay_status + '?token=' + token)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError)
  }

  getPaymentProfiles(token: Object) {
    return this.http
      .get(this.get_payment_profiles + '?token=' + token)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  validateCard(token: Object) {
    return this.http
      .post(this.validate_card, token)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  updateCard(card_detail: Object) {
    return this.http
      .post(this.update_card, card_detail)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }
  setPrimaryCard(token: Object) {
      return this.http
        .post(this.set_primary_card, token)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  }

  setAutoPay(data: Object) {
      return this.http
        .post(this.set_auto_pay, data)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  }

  updateAutoPayStatus(token: string, paymentMethodToken: string) {
    return this.http
      .put(this.update_auto_pay + '?token=' + token + '&paymentMethodToken=' + paymentMethodToken, {})
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }

  toggleAutoPay(token: string) {
		return this.http
			.put(this.toggle_auto_pay + '?token=' + token, {})
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

  getAutoPay(data: Object) {
      return this.http
        .post(this.get_auto_pay, data)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  }

  deleteCard(data: Object) {
      return this.http
        .post(this.delete_card, data)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  }
  deletePaymentProfile(data: Object) {
    return this.http
      .post(this.delete_payment_profile, data)
      .toPromise()
      .then(res => res.json())
      .catch(this.handleError);
  }
  setAutoPayThreshold(data: Object) {
      return this.http
        .post(this.set_auto_pay_threshold, data)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/payment/manage-cards/manage-cards.service.ts